const Auth = {
  isAuthenticated() {
    let session = sessionStorage.getItem('session');
    return session;
  }
};

export default Auth;

